module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.6474/assets/images/breeze-agents.jpg"